import {useTranslation} from 'react-i18next';
import CalendarOutline from '../../../../assets/icons/CalendarOutline';
import ClockOutline from '../../../../assets/icons/ClockOutline';
import {TEticketEvent} from '../../../../redux/eTicket/eTicket.type';
import * as css from './EventDateTime.css';
import {getDateFormat, getHourMinutes} from '../../../../library/dates';

interface EventDateTimeProps {
    event: TEticketEvent;
}

function EventDateTime({event}: EventDateTimeProps) {
    const {t} = useTranslation('eTicket');

    const items = [
        {key: 'date', label: t('date'), value: event.date && getDateFormat(event.date, 'DD.MM.YYYY'), Icon: CalendarOutline},
        {key: 'gatesOpen', label: t('gatesOpen'), value: event.timeOpen && getHourMinutes(event.timeOpen), Icon: ClockOutline},
        {key: 'startsAt', label: t('startsAt'), value: event.timeStart && getHourMinutes(event.timeStart), Icon: ClockOutline}
    ].filter(item => item.value);

    return (
        <css.row data-cy="ticket-event-datetime">
            {items.map(({key, label, value, Icon}) => (
                <css.col key={key}>
                    <css.colLabel>{label}</css.colLabel>
                    <css.colValue>
                        <css.iconWrap><Icon /></css.iconWrap>
                        <span>{value}</span>
                    </css.colValue>
                </css.col>
            ))}
        </css.row>
    );
}

export default EventDateTime;
